<template>
  <el-dialog
    :title="tkTitle"
    width="50%"
    :visible.sync="visible"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="课件名称">
        <el-input
          v-model="form.name"
          :disabled="ifChecks"
          maxlength="100"
          placeholder="最长可输入100字"
        ></el-input>
      </el-form-item>
      <el-form-item label="知识点">
        <el-select
          v-model="form.knows"
          placeholder="请选择"
          :disabled="ifChecks"
          @change="getKnows"
          @clear="selectClear"
          @blur="selectBlur"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.knowledgeName"
            :value="item.id"
          >
            {{ item.knowledgeName }}
          </el-option>
          <div
            @click="getList(courseWareId)"
            v-show="more"
            style="
              text-align: center;
              font-size: 12px;
              color: #ccc;
              padding: 5px 0;
              cursor: pointer;
            "
          >
            点击更多
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="类型" v-show="locationShow">
        <el-radio-group
          v-model="form.radio"
          @change="chooseModel"
          :disabled="ifChecks"
        >
          <el-radio :label="1">视频</el-radio>
          <el-radio :label="2">音频</el-radio>
          <el-radio :label="4">文档</el-radio>
          <el-radio :label="3">文本</el-radio>
          <el-radio :label="5">音视频链接</el-radio>
        </el-radio-group>
        <el-input v-model="links" v-if="showLinks"></el-input>
        <el-upload
          class="upload-demo"
          :action="url + '/zkfz/file/addUploadFile'"
          :before-upload="beforeUpload"
          :on-success="successUp"
          :on-error="errorUp"
          :on-change="handleChange"
          :on-preview="handlePreview"
          :file-list="form.fileList"
        >
          <el-button size="small" type="primary" v-if="ifUpload"
            >点击上传</el-button
          >
        </el-upload>
      </el-form-item>
      <el-form-item label="时长" v-if="ifDurations">
        <el-time-picker
          :disabled="form.radio != '5' || ifChecks"
          v-model="durations"
          :picker-options="{}"
          value-format="HH:mm:ss"
          format="HH:mm:ss"
          placeholder="请输入时长"
        >
        </el-time-picker>
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      style="width: 100%; display: inline-block; text-align: center"
      v-show="checks"
    >
      <el-button type="primary" @click="upLocation">上传本地文件</el-button>
      <el-button type="primary" @click="upCoureware">选择课件库文件</el-button>
    </span>

    <span
      slot="footer"
      v-if="ifLocations"
      style="
        width: 100%;
        display: inline-block;
        text-align: center;
        margin-top: 20px;
      "
    >
      <el-button type="primary" @click="keepUp">保 存</el-button>
      <el-button type="" @click="visible = false">返 回</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { http } from '@/utils/axios'
import * as api from '@/api/courseStructure/courseStructure'
export default {
  props: ['userType'],
  inject: ['reload'],
  name: 'CourseEditCourse',
  data() {
    return {
      courseWareId: '',
      ifChecks: false,
      checks: false,
      ifUpload: true,
      tkTitle: '',
      ifDurations: false,
      durations: '',
      ifLocations: false,
      showLinks: false,
      visible: false,
      form: {
        name: '',
        knows: '',
        radio: 1,
        fileList: [],
      },
      links: '',
      options: [],
      locationShow: false,
      institutionId: '',
      zyVideoId: '',
      knowledgeId: '',
      file: '',
      fileId: '',
      structureId: '',
      downloadId: '',
      ifEditTypes: '',
      isUpload: true,
      page: 0,
      more: true,
    }
  },
  methods: {
    getList(courseWareId) {
      this.page++
      api
        .knowLegGetList({
          page: this.page,
          pageSize: '10',
          courseWareId: courseWareId,
        })
        .then(({ data }) => {
          data = data.data
          if (data.total < 10) {
            this.more = false
          }
          if (this.page * 10 > data.total) {
            this.more = false
          }
          this.options = [...this.options, ...data.list]
        })
      this.getSchoolByUid()
    },

    getKnows(value) {
      this.knowledgeId = value
    },
    selectClear() {
      this.knowLeg = ''
    },
    selectBlur(e) {
      if (e.target.value !== '') {
        this.knowLeg = e.target.value
      }
    },
    // 时分秒转秒
    toS(time) {
      let times = time.split(':')
      let second = times.length > 0 ? parseInt(times.pop()) : 0
      if (second >= 60) throw Error('格式不正确')
      let minute = times.length > 0 ? parseInt(times.pop()) : 0
      if (minute >= 60) throw Error('格式不正确')
      let hour = times.length > 0 ? parseInt(times.pop()) : 0
      if (hour >= 24) throw Error('格式不正确')

      let secondCount = hour * 3600
      secondCount += minute * 60
      secondCount += second
      return secondCount
    },

    keepUp() {
      if (this.form.radio != '5') {
        if (this.file === '') {
          return this.$message.error('需要上传附件')
        }
      } else {
        if (this.links === '') {
          return this.$message.error('请填写音视频链接')
        }
      }
      if (!this.isUpload) return this.$message.error('请上传正确的文件后保存')

      if (
        this.form.radio == '1' ||
        this.form.radio == '2' ||
        this.form.radio == '5'
      ) {
        if (
          this.durations == '' ||
          this.durations == null ||
          this.durations == undefined
        ) {
          this.$message({ type: 'error', message: '请选择时长' })
          return false
        }
      }
      if (!this.form.name) {
        this.$message({ type: 'error', message: '请输入名称' })
      } else if (!this.form.knows) {
        this.$message({ type: 'error', message: '请选择知识点' })
      } else {
        let formdata = new FormData()
        if (this.ifEditTypes == '2') {
          formdata.append('id', this.downloadId)
        }
        formdata.append('uid', this.getUId)
        formdata.append('title', this.form.name)
        formdata.append('ctime', Date.parse(new Date()) / 1000)
        formdata.append('institutionId', this.institutionId)
        formdata.append('zyVideoId', this.zyVideoId)
        // formdata.append('knowledgeId',this.knowledgeId)
        formdata.append('knowledgeId', this.form.knows)
        formdata.append('type', this.form.radio)
        if (this.form.radio == '5') {
          formdata.append('videoAddress', this.links)
        } else {
          // formdata.append('file', this.file)
          formdata.append('fileId', this.fileId)
        }
        if (
          this.form.radio == '1' ||
          this.form.radio == '2' ||
          this.form.radio == '5'
        ) {
          formdata.append('duration', this.toS(this.durations))
        }
        formdata.append('zyVideoSectionId', this.structureId)
        api.updateVideoData(formdata).then(({ data }) => {
          // data = data.data
          if (data.code == 100000) {
            this.$message({ type: 'success', message: data.msg })
            this.reload()
          } else {
            this.$message({ type: 'success', message: data.msg })
          }
        })
      }
    },

    chooseModel() {
      this.form.fileList = []
      this.durations = ''
      if (this.form.radio == '5') {
        this.showLinks = true
        this.ifDurations = true
        this.ifUpload = false
      } else if (this.form.radio == '1' || this.form.radio == '2') {
        this.showLinks = false
        this.ifDurations = true
        this.ifUpload = true
      } else {
        this.showLinks = false
        this.ifDurations = false
        this.ifUpload = true
      }
    },

    // 初始化
    init(structureId, id, name, courseWareId, ifEditTypes, videoDataId) {
      //ifEditTypes: 1新增 2编辑
      this.structureId = structureId
      this.visible = true
      this.zyVideoId = id
      this.downloadId = videoDataId
      this.courseWareId = courseWareId
      this.getList(courseWareId)
      this.ifEditTypes = ifEditTypes

      if (ifEditTypes == '1') {
        this.checks = true
        this.tkTitle = '添加课件'
        this.form.name = ''
        this.form.knows = ''
        this.form.radio = 1
        this.links = ''
        this.form.fileList = []
        this.durations = ''
        this.locationShow = false
        this.ifDurations = false
        this.ifLocations = false
        this.ifChecks = false
      } else {
        // 改为查看不可编辑--start
        this.ifChecks = true
        this.ifLocations = true
        this.checks = false
        // this.tkTitle = '编辑课件'
        this.tkTitle = '查看课件'
        // 改为查看不可编辑--end
        this.form.fileList = []
        api
          .getDetail({ id: videoDataId, courseWareId: courseWareId })
          .then(({ data }) => {
            data = data.data
            this.form.name = data.title
            this.form.knows = data.knowledgeId
            if (
              data.type == null ||
              data.type == undefined ||
              data.type == ''
            ) {
            } else {
              // this.ifLocations = true // 改为查看不可编辑
              this.form.radio = data.type
              if (this.form.radio == '5') {
                this.showLinks = true
                this.links = data.videoAddress
                this.ifDurations = true
                this.ifUpload = false
                this.durations = this.secondsFormat(data.duration)
              } else if (this.form.radio == '1' || this.form.radio == '2') {
                this.showLinks = false
                this.ifDurations = true
                this.ifUpload = true
                this.durations = this.secondsFormat(data.duration)
                this.form.fileList.push({ name: data.fileName, url: data.url })
              } else {
                this.showLinks = false
                this.ifDurations = false
                this.ifUpload = true
                this.form.fileList.push({ name: data.fileName, url: data.url })
              }
              this.locationShow = true
            }
          })
      }
    },

    // 秒转时分秒
    secondsFormat(value) {
      var secondTime = parseInt(value) // 秒
      var minuteTime = 0 // 分
      var hourTime = 0 // 小时
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60)
        secondTime = parseInt(secondTime % 60)
        if (minuteTime > 60) {
          hourTime = parseInt(minuteTime / 60)
          minuteTime = parseInt(minuteTime % 60)
        }
      }
      var result =
        '' +
        (parseInt(secondTime) < 10
          ? '0' + parseInt(secondTime)
          : parseInt(secondTime))

      // if (minuteTime > 0) {
      result =
        '' +
        (parseInt(minuteTime) < 10
          ? '0' + parseInt(minuteTime)
          : parseInt(minuteTime)) +
        ':' +
        result
      // }
      // if (hourTime > 0) {
      result =
        '' +
        (parseInt(hourTime) < 10
          ? '0' + parseInt(hourTime)
          : parseInt(hourTime)) +
        ':' +
        result
      // }
      return result
    },

    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      this.file = file.raw
    },

    handlePreview() {
      window.open(
        this.url + '/zkfz/elZyVideoSection/getFile?id=' + this.downloadId
      )
    },

    async beforeUpload(file) {
      this.isUpload = false
      if (this.form.radio == '1') {
        //视频
        const isJPG = file.type === 'video/mp4'
        const isLt2M = file.size / 1024 / 1024 < 1024

        if (!isJPG) {
          return this.$message.error('上传文件只能是 mp4 类型!')
        }
        if (!isLt2M) {
          return this.$message.error('上传文件大小不能超过 1G!')
        }
        // return isJPG && isLt2M
        await this.getDuration(file)
        return (this.isUpload = true)
      } else if (this.form.radio == '2') {
        //音频
        const isJPG = file.type === 'audio/mpeg'
        const isLt2M = file.size / 1024 / 1024 < 1024

        if (!isJPG) {
          return this.$message.error('上传文件只能是 mp3 类型!')
        }
        if (!isLt2M) {
          return this.$message.error('上传文件大小不能超过 1G!')
        }
        // return isJPG && isLt2M
        await this.getDuration(file)
        return (this.isUpload = true)
      } else if (this.form.radio == '4') {
        //文档
        const isJPG = file.type == 'application/pdf'
        const isLt2M = file.size / 1024 / 1024 < 1024

        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 1G!')
          return false
        }
        if (!isJPG) {
          this.$message.error('上传文件只能是 pdf 类型!')
          return false
        }
        // return isLt2M && isJPG
        return (this.isUpload = true)
      } else if (this.form.radio == '3') {
        //文本
        const isJPG = file.type === 'text/plain'
        const isLt2M = file.size / 1024 / 1024 < 1024

        if (!isJPG) {
          return this.$message.error('上传文件只能是 txt 类型!')
        }
        if (!isLt2M) {
          return this.$message.error('上传文件大小不能超过 1G!')
        }
        // return isJPG && isLt2M
        return (this.isUpload = true)
      }
    },

    // 处理弹窗关闭事件
    handleClose(msg) {
      this.visible = false
      // this.reload()
      // this.$router.push({
      //   name: 'CourseContentManager',//tab所在的页面
      //   query: {
      //     type: 'third'
      //   }
      // })
      // this.$emit('close-registration-review-edit', msg)
    },

    upLocation() {
      this.locationShow = true
      this.ifLocations = true
      this.ifDurations = true
    },

    upCoureware() {
      this.locationShow = false
      this.ifLocations = false
      this.$emit('sendChooseId', this.downloadId)
      this.$emit('sendName', this.form.name)
      this.$emit('sendKnows', this.form.knows)
      this.visible = false
    },

    successUp(res, file, fileList) {
      let formdata = new FormData()
      formdata.append('file', file.raw)
      if (res.code === 100000) {
        this.fileId = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    errorUp(err, file, fileList) {
      this.isUpload = false
      return this.$message.error(err)
    },
    // 获取当前机构
    getSchoolByUid() {
      api.getSchoolByUid(this.getUId).then(({ data }) => {
        this.institutionId = data.data.id
      })
    },
    getDuration(file) {
      var binaryData = []
      // 传入file
      binaryData.push(file)
      //获取视频或者音频时长
      var fileurl = URL.createObjectURL(
        new Blob(binaryData, { type: 'application/zip' })
      )
      //经测试，发现audio也可获取视频的时长
      var audioElement = new Audio(fileurl)
      var duration = ''
      audioElement.addEventListener('loadedmetadata', (_event) => {
        duration = audioElement.duration
        this.durations = this.times(duration)
      })
      return duration
    },
    times(data) {
      var time = Number(data)
      var h = Math.floor(time / 3600)
      var m = Math.floor((time % 3600) / 60)
      var s = parseInt(time % 3600) % 60
      var hh = h < 10 ? '0' + h : h
      var mm = m < 10 ? '0' + m : m
      var ss = s < 10 ? '0' + s : s
      return hh + ':' + mm + ':' + ss
    },
  },
  created() {
    // this.getList()
    // this.getSchoolByUid()
  },
  activated() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  @include flex(center, flex-start);
  .info {
    width: 50%;
    border-right: 1px solid #4e5359;
    &:nth-last-child(1) {
      border-right: none;
    }
    .info-title {
      @include font(18px, #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form {
    .el-form-item {
      margin-left: 40px;
      width: 80%;
    }
  }
}
</style>
<style>
.el-dialog {
  width: 60%;
}
.chooseCourse {
  margin-right: 10px;
  font-size: 12px;
  line-height: 30px;
}
.courseChoose .courses {
  display: block;
  padding-left: 5%;
  padding-top: 10px;
}
.courseChoose {
  width: 25%;
  float: left;
  border-right: 1px dashed #ccc;
  margin-top: 20px;
  padding-bottom: 10px;
}
.courseChoose:last-child {
  border-right: none;
}
.el-checkbox__label {
  white-space: normal;
  padding-left: 5px;
}
.focusing .el-icon-close-tip {
  display: none !important;
}
</style>
